import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-handler',
  template: '',
})
export class ThemeHandlerComponent implements OnInit, OnDestroy {
  private observer?: MutationObserver;
  private readonly themeAttribute = 'data-rds-theme';
  private readonly themeElement = document.documentElement;

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  ngOnInit(): void {
    this.applyThemes();

    this.observer = new MutationObserver(() => this.applyThemes());
    this.observer.observe(this.themeElement, {
      attributes: true,
      attributeFilter: [this.themeAttribute],
    });
  }

  private applyThemes(): void {
    const current = this.themeElement.getAttribute(this.themeAttribute) ?? '';
    const themes = new Set(current.split(/\s+/).filter(Boolean));
    themes.add('rbo');

    const updated = [...themes].join(' ');
    if (updated !== current) {
      this.themeElement.setAttribute(this.themeAttribute, updated);
    }
  }
}
